/**
 * The base colors for the Soft UI Dashboard PRO Material.
 * You can add new color using this file.
 * You can customized the colors for the entire Soft UI Dashboard PRO Material using thie file.
 */

 export default {
  background: {
    default: "#f0f2f5",
  },

  text: {
    main: "#0C0C0D",
    focus: "#7b809a",
  } as any,

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#097384",
    focus: "#097384",
  },

  secondary: {
    main: "#505b60",
    focus: "#505b60",
  },

  info: {
    main: "#097384",
    focus: "#097384",
  },

  success: {
    main: "#2e7d32",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: "#d32f2f",
    focus: "#f65f53",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },
  grey: {
    100: "#eaeaf0",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  green: {
    main: "#2f7d31"
  },

  blue:{
    main: "#0478bd"
  },

  lightTeal:{
    main: "#6c9dac"
  },

  gradients: {
    primary: {
      main: "#EC407A",
      state: "#D81B60",
    },

    secondary: {
      main: "#747b8a",
      state: "#495361",
    },

    info: {
      main: "#779caa",
      state: "#097384",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#42424a",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  ui: {
    activeBackground:      '#0D7E8E',
    activeBackgroundHover: '#0A6370',
    border:                '#E0E4E8',
    secondaryText:         '#666666',
    tertiaryText:          '#999999',
    mutedText:             '#9CA3AF',
    dimmedText:            'rgba(52,71,103,0.2)',
    sampleCellBackground:  '#F5F5F5',
    naBackground:          '#F9FAFB',
    naBorder:              '#D1D5DB',
    cellHoverShadow:       '0 4px 12px rgba(0,0,0,0.15)',
    tableHeaderBand:         '#2F444B',
    tableHeaderBandBorder:   '#4A5F66',
    subtotalRowBackground:   '#F5F5F5',
    subtotalRowEmphasisBg:   '#DDE3E5',
    subtotalRowBorder:       '#2F444B',
    tintedColumnBg:          '#EEF1F3',
    eea2CardBackground:      '#eff6ff',
    eea2CardBorder:          '#bfdbfe',
  },

  empowermentFinancing: {
    sectionHeaderBackground: '#F4F3EF',
    tableHeaderBackground:   '#4D4F53',
    applicableYearHeaderBg:  '#097384',
    applicableYearCellBg:    'rgba(9,115,132,0.06)',
    totalRowBackground:      '#F0F4F8',
    alternateRowBackground:  '#FAFAFA',
    proportionBarTrack:      '#E0E4E8',
    ratioValidBackground:    '#d1fae5',
    ratioValidText:          '#065f46',
    ratioInvalidBackground:  '#fee2e2',
    ratioInvalidText:        '#991b1b',
    savedConfirmation:       '#2e7d32',
  },

  deviationVariance: {
    negative: { bg: '#FCD3D0', sign: '#FF0000', cellText: '#DC2626' },
    neutral:  { bg: '#BCE2BE', sign: '#008000', cellText: '#16A34A' },
    positive: { bg: '#FFD59F', sign: '#C87000', cellText: '#C87000' },
  },

  deviationSeverity: {
    critical:        { bg: '#FCE7F3', bgHover: '#FBCFE8', icon: '#831843', iconBg: '#F472B6', barBorder: '#FCA5A5', barBg: '#FFF1F2', barIconBg: '#F87171', barText: '#881337' },
    high:            { bg: '#F3E8FF', bgHover: '#E9D5FF', icon: '#581C87', iconBg: '#C084FC', barBorder: '#C4B5FD', barBg: '#F5F3FF', barIconBg: '#A78BFA', barText: '#4C1D95' },
    medium:          { bg: '#DBEAFE', bgHover: '#BFDBFE', icon: '#1E3A8A', iconBg: '#60A5FA', barBorder: '#93C5FD', barBg: '#EFF6FF', barIconBg: '#60A5FA', barText: '#1E3A8A' },
    onTrack:         { bg: '#CCFBF1', bgHover: '#99F6E4', icon: '#134E4A', iconBg: '#2DD4BF', barBorder: '#5EEAD4', barBg: '#F0FDFA', barIconBg: '#2DD4BF', barText: '#134E4A' },
    overRepresented: { bg: '#F3F4F6', bgHover: '#E5E7EB', icon: '#374151', iconBg: '#9CA3AF', barBorder: '#D1D5DB', barBg: '#F9FAFB', barIconBg: '#9CA3AF', barText: '#374151' },
  },

  accordionHeaderChip: {
    critical: { border: 'rgba(244, 114, 182, 0.7)', bg: 'rgba(236, 72, 153, 0.2)',  text: '#FCE7F3' },
    high:     { border: 'rgba(192, 132, 252, 0.7)', bg: 'rgba(168, 85, 247, 0.2)',  text: '#F3E8FF' },
    medium:   { border: 'rgba(96, 165, 250, 0.7)',  bg: 'rgba(59, 130, 246, 0.2)',  text: '#DBEAFE' },
    onTrack:  { border: 'rgba(45, 212, 191, 0.7)',  bg: 'rgba(20, 184, 166, 0.2)',  text: '#CCFBF1' },
    captured: { border: 'rgba(96, 165, 250, 0.7)',  bg: 'rgba(59, 130, 246, 0.2)',  text: '#DBEAFE' },
    neutral:  { border: 'rgba(255, 255, 255, 0.4)', bg: 'rgba(255, 255, 255, 0.1)', text: 'rgba(255, 255, 255, 0.8)' },
  },

  deviationBadge: {
    positive: { bg: '#DCFCE7', text: '#166534', border: '#BBF7D0' },
    negative: { bg: '#FEE2E2', text: '#991B1B', border: '#FECACA' },
    neutral:  { bg: '#F3F4F6', text: '#6B7280', border: '#E5E7EB' },
    appointedRow: '#E1F1F3',
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },

  eea2KeyReason: {
    yes: { background: "#DBEAFE", text: "#1E40AF" },
    no:  { background: "#F3F4F6", text: "#6B7280" },
  },
};
